import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberString',
    standalone: false
})
export class NumberStringPipe implements PipeTransform {
  transform(value: number): string {
    // transforms number to comma seprated string
    return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
  }
}
